
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';

import Icon from '../../components/Icon/IconSvg'

import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    BorderLinearProgress
} from '../../components';

import {
    Card
} from '../../components'


import useCopy from '../../hook/useCopy'


import {
    useEthers
} from '../../ethers/index'

import {
    useAdmin,
    useFounderApprove,
    useSetConfiguration,
    useSilverVIP,
    useGoldVIP
} from '../../hook/silver/useAdmin'
// import { getValue } from '@testing-library/user-event/dist/utils';
import { EtherToInt } from '../../ethers/e';
import { useEffect } from 'react';

function ShareLink() {
    const {account} = useEthers()
    const copy = useCopy()
    const invitLink = () => {
        copy(window.location.href+'?r=' + account)
    }
    return <TextS onClick={invitLink} style={{display:'block'}} color='2'>Copy Share Link {'>'}</TextS>
}

function Approve() {
    return <Button style={{width: '100%'}} {...useFounderApprove()} />
}

function Index() {
    const {
        totalLockedUSDG,
        totalGoldUnlcokableUSDG,
        supplyOfUSDG,
        totalUnlockedUSDG,
        hardCap,
        interest7Days,
        recruitmentTime,
        silverRewardRate,
        locked,
        totalNeed
    } = useAdmin()
    // uint256 _interest7Days,
    // uint256 _silverRewardRate,
    // uint256 _recruitmentTime,
    // uint256 _hardCap
    
    const {
        button,
        input
        // {
        //     hardCap,
        //     interest7Days,
        //     recruitmentTime,
        //     silverRewardRate
        // }
    } = useSetConfiguration()

    useEffect(() => {
        input.hardCap.onChange(hardCap)
        input.silverRewardRate.onChange(silverRewardRate)
        input.recruitmentTime.onChange(recruitmentTime)
        input.interest7Days.onChange(interest7Days)
    }, [hardCap, interest7Days, recruitmentTime, silverRewardRate])

    return (
        <Container>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <TextM style={{display:'block'}}>Need USDT</TextM>
                <TextM style={{display:'block'}}><TextM color='2'>Locked USDG </TextM> {EtherToInt(locked)}</TextM>
                <TextM style={{display:'block'}}><TextM color='2'>Supply USDG </TextM> {EtherToInt(supplyOfUSDG)}</TextM>
                <TextM style={{display:'block'}}><TextM color='2'>Total USDG </TextM> {EtherToInt(totalNeed)}</TextM>
            </Card>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <TextM>Silver Configuration</TextM>
                <Input
                    style={{
                        marginBottom: '6px'
                    }}
                    inputStyle={{textAlign: 'right'}}
                    before={<TextS>interest7Days</TextS>}
                    input={input.interest7Days}
                />
                <Input
                    style={{
                        marginBottom: '6px'
                    }}
                    inputStyle={{textAlign: 'right'}}
                    before={<TextS>silverRewardRate</TextS>}
                    input={input.silverRewardRate}
                />
                <Input
                    style={{
                        marginBottom: '6px'
                    }}
                    inputStyle={{textAlign: 'right'}}
                    before={<TextS>recruitmentTime|1day=24*3600</TextS>}
                    input={input.recruitmentTime}
                />
                <Input
                    style={{
                        marginBottom: '6px'
                    }}
                    inputStyle={{textAlign: 'right'}}
                    before={<TextS>hardCap</TextS>}
                    input={input.hardCap}
                />
                <Button style={{width: '100%'}} {...button}>Set</Button>
            </Card>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <TextM style={{marginBottom: '6px'}}>Founder Approve USDT</TextM>
                <Approve />
            </Card>
            <WhiteSpace />
            <SetSilver />
            <WhiteSpace />
            <SetCold />
        </Container>
    )
}

export default Index

function SetSilver() {
    const {
        button,
        inputAddress,
        isVIP
    } = useSilverVIP()
    return (
        <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
            <TextM style={{marginBottom: '6px'}}>Set Silver VIP</TextM>
            <Input
                style={{
                    marginBottom: '6px'
                }}
                before={<TextS>user</TextS>}
                input={inputAddress}
            />
            <TextM style={{marginBottom: '6px'}}>VIP - {isVIP}</TextM>
            <Button style={{width: '100%'}} {...button}/>
        </Card>
    )
}

function SetCold() {
    const {
        button,
        inputAddress,
        isVIP
    } = useGoldVIP()
    return (
        <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
            <TextM style={{marginBottom: '6px'}}>Set Gold VIP</TextM>
            <Input
                style={{
                    marginBottom: '6px'
                }}
                before={<TextS>user</TextS>}
                input={inputAddress}
            />
            <TextM style={{marginBottom: '6px'}}>VIP - {isVIP}</TextM>
            <Button style={{width: '100%'}} {...button}/>
        </Card>
    )
}
// useSilverVIP,
//     useGoldVIP